import styled from 'styled-components';

export const Container = styled.div`
  overflow: auto;
  height: 100%;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 9;
  }

  th {
    text-align: left;
    background: #fff;
  }

  td {
    padding: 16px 0;
    color: #1a1b1c;
    font-size: 16px;
  }

  tr + tr {
    border-top: 1px solid #d0dae3;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Profile = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
`;

export const MenuImg = styled.img`
  cursor: pointer;
`;

export const Head = styled.div`
  background: #fff;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #8f95b2;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #e6e8f0;

  &.first-header {
    border-top-left-radius: 8;
    border-bottom-left-radius: 8;
    padding-left: 7;
  }

  &.role-header {
    padding-right: 7;
  }

  &.menu-header {
    border-top-right-radius: 8;
    border-bottom-right-radius: 8;
  }
`;

export const MenuDiv = styled.div`
  visibility: hidden;
  font-size: inherit;
`;

export const Invite = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

interface IText {
  status?: string;
}

export const Text = styled.div<IText>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ status }) => {
    if (status === 'accepted') return '#474d66';
    return '#8f95b2';
  }};

  &.currentUser {
    color: #474d66;
  }

  &.role {
    color: #474d66;
  }

  &.small {
    font-size: 12px;
    color: #474d66;
  }
`;

interface IMenuContainer {
  display: boolean;
}

export const MenuContainer = styled.div<IMenuContainer>`
  display: ${({ display }) => (display ? 'flex' : 'none')};
`;

export const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;

  margin-bottom: 24px;
`;

export const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const WrapperCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputSearch = styled.input`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const FilterButton = styled.button`
  display: flex;
  height: 42px;
  padding: 16px 13px 11px 13px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  background-color: transparent;
  align-items: center;
`;

export const AddButton = styled.button`
  display: flex;
  height: 42px;
  padding: 10px 16px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  background-color: transparent;
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
  gap: 10px;
`;

export const LinkText = styled.a`
  font-size: 12px;
  font-weight: 500;
  color: #1372fe;
  text-decoration: underline;
`;
